<div class="gojs-editing-container">
  <div class="grid-x">
    <div class="cell shrink">
      <label class="inline">
        Editing:
        <input type="text" class="inline no-margin-bottom label-margin-left" placeholder="Enter a workflow name" id="workflowName"
          [(ngModel)]="template.name" />
        </label>
        <span class="checkbox">
          <input class="show-for-sr no-margin-bottom" type="checkbox" id="isPublicTemplate" [(ngModel)]="template.isPublic">
          <label for="isPublicTemplate" class="inline">
            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
            <span class="control-label-text">User authentication not required</span>
          </label>
        </span>
      </div>
      <div class="cell auto text-right">
        <div class="grid-x">
          <div class="cell auto">
            <label class="inline" for="dtpckrEffectiveStartDate">Effective From:</label>
            <div class="margin-right display-inline-block">
              <common-date-picker [id]="'dtpckrEffectiveStartDate'" [initialDate]="template?.effectiveDate" (dateUpdated)="startDateChange($event)" [placeholder]="placeholder"></common-date-picker>
            </div>
          </div>
          <div class="cell shrink">
            <div class="button-menu-container">
              <div>
                <button (click)="saveAs('draft')" class="button-menu-first">Save Draft</button>
                <button class="button-menu-down-arrow" (click)="showSaveOptions(!saveOptionsVisible)">
                  <span class="show-for-sr">Show Save Options</span>&#9662;</button>
                </div>
                @if (saveOptionsVisible) {
                  <div class="button-menu-options-container">
                    @if (saveOptionsVisible) {
                      <button (click)="saveAs('publish')">Publish</button>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="cell small-12">
          <label class="inline">
            Version:
            <span id="versionNumber" class="major-margin-right">{{versionId}}</span>
          </label>
          <label class="inline">
            Effective Date:
            <span id="publishedDate" class="major-margin-right">{{publishedDate}}</span>
          </label>
          <label class="inline">
            Last Edited By:
            <span id="lastEditedBy" class="major-margin-right">{{lastEditedBy}}</span>
          </label>
          <label class="show-for-sr" for="versionSelect">Load Version</label>
          @if (isLoadingVersions) {
            <span class="input-height">Loading Versions...</span>
          }
          @if (!isLoadingVersions) {
            <select id="versionSelect" aria-label="Load Version" class="inline no-margin-bottom" [(ngModel)]="versionId" (ngModelChange)="versionAs($event)">
              @for (vrsnOptn of versionOptions; track vrsnOptn) {
                <option [value]="vrsnOptn.id">{{vrsnOptn.text}}</option>
              }
            </select>
          }
          <a class="button" [attr.href]="exportUrl">Export</a>
        </div>
      </div>
      <div class="cell small-12 margin-top">
        <workflow-builder-tabs (setTabEvent)="setTabEvent($event)"></workflow-builder-tabs>
      </div>
    </div>
    @if (showTab === 'diagram') {
      <workflow-diagram [template]="template" [moduleGroupId]="moduleGroupId" [moduleId]="moduleId"></workflow-diagram>
    }
    @if (showTab === 'context') {
      <workflow-context [template]="template"></workflow-context>
    }
    <confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
